import {defineNuxtRouteMiddleware} from '#app';
import {safelyNavigateTo} from '@malt/utils';

export default defineNuxtRouteMiddleware(async (to, _from) => {
    if (to.path.startsWith('/admin')) {
        const redirectedPath = to.path.replace('/admin', '/project-admin');
        return await safelyNavigateTo({...to, path: redirectedPath}, {replace: true, externalToThisApp: true});
    }
});
